export const messagesTypes = {
  bot: 0,
  user: 1,
  client: 2,
};

export const messagesContentType = {
  chat: 'chat',
  image: 'image',
};
